import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { ObjectType } from 'typescript';
import CharacterData from '../../assets/data/characters-data';
import ImageStorage from '../../utils/ImageStorage';
import CharacterItem from './CharacterItem';
import CharacterDetailModal from './CharacterModal';

enum CharacterType {
  HERO = 'HERO',
  WIFE = 'WIFE',
}

const CharactersPage = () => {
  const { hash } = useLocation();
  const [currentTab, setCurrentTab] = useState<string>(CharacterType.HERO);
  const [isShowCharacterModal, setShowCharacterModal] =
    useState<boolean>(false);
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const [currentCharacter, setCurrentCharacter] = useState<any>({});

  useEffect(() => {
    if (hash === '' || hash === '#mon-khach') {
      setCurrentTab(CharacterType.HERO);
    } else {
      setCurrentTab(CharacterType.WIFE);
    }
  }, []);

  const handleClickCharacter = (index: number) => {
    setCurrentIndex(index);
    const character = getCharacterFromDB(index);
    if (character) {
      setCurrentCharacter(character);
      setShowCharacterModal(true);
    }
  };

  const handleClickPrev = () => {
    if (currentIndex - 1 >= 0) {
      handleClickCharacter(currentIndex - 1);
    }
  };

  const handleClickNext = () => {
    if (currentIndex + 1 <= getCurrentCharacterArr().length - 1) {
      handleClickCharacter(currentIndex + 1);
    }
  };

  const getCharacterFromDB = (index: number) => {
    const arr = getCurrentCharacterArr();
    return arr[index];
  };

  const getCurrentCharacterArr = () => {
    if (currentTab === CharacterType.HERO) {
      return CharacterData.HERO;
    }
    return CharacterData.WIFE;
  };

  return (
    <>
      <CharacterDetailModal
        isShow={isShowCharacterModal}
        setShow={setShowCharacterModal}
        name={currentCharacter.name}
        desc={currentCharacter.desc}
        detail={currentCharacter.detail}
        handleClickPrev={() => handleClickPrev()}
        handleClickNext={() => handleClickNext()}
      />
      <div className='page-background'>
        <div className='characters-banner'>
          <div className='container mx-auto flex relative h-full overflow-y-visible overflow-x-visible'>
            <div className='effect w-full h-full'></div>
            <div className='banner-char'></div>
            <div className='banner-text'>
              <a className='home-button' href='/'>
                <img
                  src={ImageStorage.HomeButton}
                  alt='TOP 1 game quan đấu trên Zalo'
                />
              </a>
            </div>
          </div>
        </div>
        <div
          className='characters-tab flex flex-row justify-center'
          id='characters-tab'
        >
          <a
            className={`tab-item ${
              currentTab === CharacterType.HERO ? 'tab-item-active' : ''
            }`}
            href='#mon-khach'
            data-character='hero'
            onClick={() => {
              setCurrentTab(CharacterType.HERO);
            }}
          >
            Tướng Thần
          </a>
          <a
            className={`tab-item ${
              currentTab === CharacterType.WIFE ? 'tab-item-active' : ''
            }`}
            href='#my-nhan'
            data-character='wife'
            onClick={() => {
              setCurrentTab(CharacterType.WIFE);
            }}
          >
            Mỹ Nhân
          </a>
        </div>
        <div className='container mx-auto list-characters-container'>
          <div id='list-characters'>
            <div
              className={`list-characters ${
                currentTab !== CharacterType.HERO ? 'hidden' : ''
              }`}
              id='hero'
            >
              {CharacterData.HERO.map((character, idx) => {
                return (
                  <CharacterItem
                    key={idx}
                    thumbnail={character.thumbnail}
                    onClick={() => handleClickCharacter(idx)}
                  />
                );
              })}
            </div>
            <div
              className={`list-characters ${
                currentTab !== CharacterType.WIFE ? 'hidden' : ''
              } `}
              id='wife'
            >
              {CharacterData.WIFE.map((character, idx) => {
                return (
                  <CharacterItem
                    key={idx}
                    thumbnail={character.thumbnail}
                    onClick={() => handleClickCharacter(idx)}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CharactersPage;
